import React, { useEffect, useState } from "react";
import StepOne from "./StepOne";
import StepTwo from "./StepTwo";
import StepThree from "./StepThree";
import StepFour from "./StepFour";
import StepFive from "./StepFive";
import StepSix from "./StepSix";

const Registration = () => {
  const [allStepsData, setAllFormData] = useState({});
  const [nextStep, setNextStep] = useState(1);
  const [managerId, setManagerId] = useState();

  const renderContent = () => {
    switch (nextStep) {
      case 1:
        return (
          <StepOne
            setAllFormData={setAllFormData}
            allStepsData={allStepsData}
            setNextStep={setNextStep}
            nextStep={nextStep}
            handleNextStep={handleNextStep}
            handleManagerId={handleManagerId}
            setManagerId={setManagerId}
          />
        );

      case 2:
        return (
          <StepTwo
            setAllFormData={setAllFormData}
            allStepsData={allStepsData}
            setNextStep={setNextStep}
            nextStep={nextStep}
            handleNextStep={handleNextStep}
            managerId={managerId}
          />
        );
      case 3:
        return (
          <StepThree
            setAllFormData={setAllFormData}
            allStepsData={allStepsData}
            setNextStep={setNextStep}
            nextStep={nextStep}
            handleNextStep={handleNextStep}
            managerId={managerId}
          />
        );
      case 4:
        return (
          <StepFour
            setAllFormData={setAllFormData}
            allStepsData={allStepsData}
            setNextStep={setNextStep}
            nextStep={nextStep}
            handleNextStep={handleNextStep}
            managerId={managerId}
          />
        );
      case 5:
        return (
          <StepFive
            setAllFormData={setAllFormData}
            allStepsData={allStepsData}
            setNextStep={setNextStep}
            nextStep={nextStep}
            handleNextStep={handleNextStep}
            managerId={managerId}
          />
        );
      case 6:
        return (
          <StepSix
            setAllFormData={setAllFormData}
            allStepsData={allStepsData}
            spendingSttNextStep={setNextStep}
            nextStep={nextStep}
            handleNextStep={handleNextStep}
            managerId={managerId}
          />
        );
      default:
        return;
    }
  };
  const handleNextStep = (val) => {
    setNextStep(val);
  };

  const handleManagerId = (val) => {
    setManagerId(val);
  };
  return (
    <div className="">
      <main className="">
        {/* <Topnavigation /> */}
        {renderContent()}
      </main>
    </div>
  );
};

export default Registration;
